import React from 'react';
import AlertItem from './alertItem';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';

const AlertListContainer = styled.div`
  display: flex;
  flex-direction: column;
  left: 50%; // horizontally center in window
  transform: translateX(-50%);
  margin: 0px auto;
  max-height: 100%; // need this so list will scroll on overflow...
  overflow-y: auto;
  position: absolute;
  top: 55px;
  min-width: 320px;
  max-width: 400px;
  z-index: 1000; // make sure always on top
`;


const AlertList = (props) => {

  // console.log('ALERT LIST --', props);

  const handleDismissAlert = (id) => {
    props.cbDismissAlert(id);
  };

  const renderAlertList = (alertArray = []) => {
    // console.log('ALERT ARRAY', alertArray, alerts);
    return alertArray.map((a, i) => {
      return (
        <AlertItem
          key={a.id + '-' + i}
          alertBodyText={a.alertBodyText ? a.alertBodyText : undefined}
          alertId={a.id}
          alertLevel={a.alertLevel ? a.alertLevel : undefined}
          alertLink={a.alertLink ? a.alertLink : undefined}
          alertLinkLabel={a.alertLinkLabel ? a.alertLinkLabel : undefined}
          alertHeadingText={a.alertHeadingText ? a.alertHeadingText : undefined}
          autoCloseTimeout={a.autoCloseTimeout || a.autoCloseTimeout === 0 ? a.autoCloseTimeout : undefined}
          cbDismissAlert={handleDismissAlert}
          isPersistent={a.isPersistent ? a.isPersistent : undefined}
          type={a.type ? a.type : 'other'}
          cbClick={a.cbClick}
        />);
    });
  };


  return (
    <AlertListContainer className={"alertListContainer " + props.className}>
      {renderAlertList(props.alertArray)}
    </AlertListContainer>
  );
};


AlertList.propTypes = {
  'alertArray': PropTypes.array,
  'className': PropTypes.string,
  'cbDismissAlert': PropTypes.func
};

AlertList.defaultProps = {
  'className': ""
};


export default injectIntl(AlertList);
